import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withRouter } from 'react-router-dom'

// Material UI
import { withTheme, withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Modal from '@material-ui/core/Modal'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar'

import Utils from '../resources/Utils'

// Actions
import { CircularProgress } from '@material-ui/core' 
import MySnackbarContentWrapper from './CustomSnackBar'
import { requestEnviarCorreoCfdi } from '../actions/actions'

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const styles = theme => ({
  modalContainer: {
    overflow: 'scroll'
  },
  container: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 5,
    [theme.breakpoints.down('xs')]: {
      background: 'white',
      width: '90%',
      height: '100%',
      paddingTop: '20%',
      paddingLeft: '5%',
      paddingRight: '5%'
    }
  },
  modalTitle: {
    fontWeight: 600
  },
  largeTextField: {
    width: '100%',
    marginTop: 12
  },
  smallTextField: {
    width: '30%',
    paddingRight: '3%',
    marginTop: 12
  },
  LastSmallTextField: {
    width: '33%',
    marginTop: 12
  },
  actions: {
    float: 'right',
    marginTop: 32
  },
  primaryButton: {
    marginLeft: 16,
    fontWeight: 600,
    fontSize: 14
  },
  select: {
    width: "100%"
  },
  root: {
    display: 'flex',
    float: 'right',
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

class SendMailModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      loading: false,
      errorMessage: '',
      openSnack: false
    }
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.clearData = this.clearData.bind(this)
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleRender = this.handleRender.bind(this)

  }

  componentDidUpdate(prevProps) {
    if (Utils.isUserLoggedIn()) {
      if (prevProps.init.enviarCorreoCfdi !== this.props.init.enviarCorreoCfdi) {
        const { data, status } = this.props.init.enviarCorreoCfdi
        if(status === Utils.constants.status.ok){
          this.handleClose()
        } else {
          this.setState({
            errorMessage: 'No se ha podido enviar el correo',
            openSnack: true,
            variant: 'error'
          })       
        }
        this.setState({loading: false})
      }
    }
  }
  handleChangeEmail(event) {
    this.setState({email: event.target.value})
  }

  handleConfirm() {
    const emailsString = this.state.email
    const emails = emailsString.split(",")
    var emailsValid = true
    emails.forEach((email) => {
        if(!Utils.validateEmail(email)){
            emailsValid = false
        }
    })
    if(emailsValid){
        this.setState({loading: true})
        this.props.requestEnviarCorreoCfdi({ correo: emailsString, comprobanteID: this.props.payment.comprobanteID })
    } else {
        this.setState({
            errorMessage: 'Correo(s) invalido(s), favor de verificar el campo correo',
            openSnack: true,
            variant: 'warning'
        }) 
    }
  }

  handleCloseSnackbar() {
    this.setState({errorMessage: '', openSnack: false})
  }

  handleClose() {
    this.clearData()
    this.props.handleClose()
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.handleConfirm()
    }
  }

  handleRender() {
    this.setState({
      email:""
    })
  }

  clearData() {
    this.setState({
      socialName: '',
      rfc: '',
    })
  }

  render() {
    const { classes } = this.props
    const { loading } = this.state
    return (
      <Modal
        open={this.props.open}
        onEscapeKeyDown={this.handleClose}
        onBackdropClick={this.handleClose}
        className={classes.modalContainer}
        onRendered={this.handleRender}
      >
        <div style={getModalStyle()} className={classes.container}>
          <Typography variant="h4" className={classes.modalTitle}>
            Enviar a correos
          </Typography>
          <Typography variant="body1" style={{marginTop: 8}}>
            Separar por ( , ) comas para enviar a multiples correos
          </Typography>
          <form noValidate autoComplete="off" onKeyPress={this.handleKeyPress}>

            <TextField
              className={classes.largeTextField}
              label={Utils.getMessages().CFDIModal.placeholderEmail}
              type="text"
              multiline
              rows={3}
              value={this.state.email}
              onChange={this.handleChangeEmail}
              autoFocus
            />

            <div className={classes.root}>
              <Button
                  onClick={this.handleClose}
                  disabled={loading}
                >
                {Utils.getMessages().CFDIModal.cancelButton}
              </Button>

              <div className={classes.wrapper}>
                <Button
                  className={classes.primaryButton}
                  variant="contained"
                  color="primary"
                  onClick={this.handleConfirm}
                  disabled={loading}
                >
                 ENVIAR CORREO
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
              
            </div>
          </form>

              
          <Snackbar
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            open={this.state.openSnack}
            autoHideDuration={5000}
            onClose={this.handleCloseSnackbar}
          >
            <MySnackbarContentWrapper
             onClose={this.handleCloseSnackbar}
              variant={this.state.variant}
              message={
                <span>{this.state.errorMessage}</span>
              }
            />
          </Snackbar>

        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    requestEnviarCorreoCfdi: (data) => {
      dispatch(requestEnviarCorreoCfdi(data))
    },
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SendMailModal)
